import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRoute} from '@angular/router';
import { AuthService } from './auth.service';
import * as _ from 'lodash';
import { URL } from "url";

@Injectable()
export class AuthAfterloginService implements CanActivate {
  constructor(public auth: AuthService, public router: Router, public activatedRoute: ActivatedRoute) {}
  canActivate(): boolean {
    if (this.auth.isAuthenticated()) {
      this.auth.redirectUrl();
      return false;
    }
    return true;
  }
}
